import { useContext } from 'react'

import {
  Button, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import useReporting from '@hooks/useReporting'

import { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import Reporting from '@components/Reporting'

const MODAL_KEY = 'GenerateReportModal'

type ModalCallbacks = {
  closeModal: () => void,
  generateReport: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const GenerateReportModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { generateReport } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData[MODAL_KEY] || {}
  const { allowedReports, formDeps, defaultValues = {} } = modalPayload

  const reportingPayload = useReporting({ allowedReports, formDeps, defaultValues })

  const {
    callbacks: {
      generateReport: generateFn,
    },
    loading,
    saveEnabled,
  } = reportingPayload

  const generateReportPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Report Queued',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Generate" titleSecondLine="Report" />

      <SidebarModal.Content>
        <Reporting isSidebar reportingPayload={reportingPayload} />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={loading}
          // @ts-expect-error TS2345
          onClick={() => generateReport(generateReportPayload)}
          size="large"
        >
          {saveEnabled ? 'Generate Report' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <GenerateReportModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
